"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freezeBooleanAttribute = void 0;
const freeze_js_1 = require("../primitive/freeze.js");
const interface_js_1 = require("./interface.js");
/**
 * Freezes a warm `boolean` attribute
 *
 * @param state Attribute options
 * @param path Path of the instance in the related schema (string)
 * @return void
 */
const freezeBooleanAttribute = (state, path) => {
    (0, freeze_js_1.validatePrimitiveAttribute)({ type: 'boolean', ...state }, path);
    return new interface_js_1.BooleanAttribute_({ path, ...state });
};
exports.freezeBooleanAttribute = freezeBooleanAttribute;
